import { defineStore } from 'pinia'
import axios from 'axios'
import { getModalsStore } from './modals'
import router from '../router'

const langParams = () => {
  const lang_id = localStorage.getItem('language');
  return lang_id ? { lang_id } : {};
};

export const getStaticStore = defineStore('staticStore', {
  state: () => ({
    pages: [],
    textPageData: {},
    textPageIdentifier: null,
    error: ''
  }),
  getters: {
    termsPage: state => state.pages.find(page => page.title && page.title.toLowerCase().includes('terms')),
    privacyPage: state => state.pages.find(page => page.title && page.title.toLowerCase().includes('privacy')),
    cookiePage: state => state.pages.find(page => page.title && page.title.toLowerCase().includes('cookie')),
  },
  actions: {
    async fetchData() {
      try {
        const response = await axios.get(process.env.VUE_APP_API + 'static-pages', {
          params: langParams()
        });
        this.pages = response.data.payload;
      } catch (err) {
        this.error = err.message;
      }
    },
    goToPage(item) {
      let targetPage = null;
      if (item == 'privacy') {
        targetPage = this.privacyPage;
      } else if (item == 'terms') {
        targetPage = this.termsPage;
      } else if (item == 'cookie') {
        targetPage = this.cookiePage;
      } else {
        // Handle direct ID or slug
        targetPage = this.pages.find(p => p.id == item || p.slug === item);
      }

      if (targetPage) {
        const route = targetPage.slug ? `/${targetPage.slug}` : `/pages/${targetPage.id}`;
        router.push(route);
        this.getTextPageContent(targetPage.slug || targetPage.id);
      }
      getModalsStore().closeSignUp();
    },
    async getTextPageContent(identifier) {
      this.textPageData = {};
      this.textPageIdentifier = identifier;
      try {
        const res = await axios.get(process.env.VUE_APP_API + 'static-pages/' + identifier, {
          params: langParams()
        });
        this.textPageData = res.data.payload;
      } catch (err) {
        this.error = err.message;
      }
    },
    async refreshForLanguage() {
      await this.fetchData();
      const route = router.currentRoute.value;
      if (this.textPageIdentifier && ['StaticPageBySlug', 'TextPage'].includes(route.name)) {
        await this.getTextPageContent(this.textPageIdentifier);
      }
    },
  },
});

